import Table from "@/components/table";
import { useTanStackTable } from "@/components/table/custom/use-TanStack-Table";
import TableFooter from "@/components/table/footer";
import TablePagination from "@/components/table/pagination";
import { appointmentData } from "@/data/appointment-data";
import { Box } from "rizzui";
import { appointmentColumns } from "./columns";
import Filters from "./filters";

export type AppointmentDataType = (typeof appointmentData)[number];

export default function AppointmentListTable() {
    const { table, setData } = useTanStackTable<AppointmentDataType>({
        tableData: appointmentData,
        columnConfig: appointmentColumns,
        options: {
            initialState: {
                pagination: {
                    pageIndex: 0,
                    pageSize: 10,
                },
            },
            meta: {
                handleDeleteRow: (row) => {
                    setData((prev) => prev.filter((r) => r.id !== row.id));
                },
                handleMultipleDelete: (rows) => {
                    setData((prev) => prev.filter((r) => !rows.includes(r)));
                    table.resetRowSelection();
                },
            },
            enableColumnResizing: false,
        },
    });
    return (
        <Box>
            <Filters table={table} />
            <Table
                table={table}
                variant="modern"
                classNames={{
                    container: "border border-muted rounded-md",
                    rowClassName: "last:border-0",
                }}
            />
            <TableFooter table={table} />
            <TablePagination table={table} className="py-4" />
        </Box>
    );
}
